import type { HealingGeneratedSource } from "@/core/types"

export const MAX_AI_HEALING_VARIATIONS = 10
export const canAddAiHealingVariationBatch = (
	existingVariationCount: number,
	maxVariations = MAX_AI_HEALING_VARIATIONS,
): boolean => existingVariationCount < maxVariations

export const stackAiHealingVariations = (
	existingVariations: HealingGeneratedSource[] | undefined,
	newVariations: HealingGeneratedSource[],
	maxVariations = MAX_AI_HEALING_VARIATIONS,
): {
	aiVariations: HealingGeneratedSource[]
	selectedVariation: number
} => {
	const maxCount = Math.max(0, Math.floor(maxVariations))
	if (maxCount === 0) {
		return { aiVariations: [], selectedVariation: 0 }
	}

	const existing = existingVariations ?? []
	const combined = [...existing, ...newVariations]
	const aiVariations = combined.slice(0, maxCount)
	if (aiVariations.length === 0) {
		return { aiVariations, selectedVariation: 0 }
	}

	const firstNewVariationIndex = Math.min(existing.length, aiVariations.length - 1)

	return {
		aiVariations,
		selectedVariation: firstNewVariationIndex,
	}
}
